<template>
    <div class="mylistwrap" v-if="isload">
        <div v-if="$common.basic.isarrayexist(infolist)" class="mylist">
            <dl class="avg listheader" v-if="!issmall">
                <dd v-if="istea&&!isviewstu">{{$common.dicword('learner')}}</dd>
                <dd v-if="isct&&!isviewstu&&1>2">{{$common.dicword('infoclass')}}</dd>
                <dd v-if="isteaview">{{$common.dicword('course')}}</dd>
                <dd>{{$common.dicword('topic')}}</dd>
                <dd>{{$common.dicword('lesson')}}</dd>
                <dd>{{$common.dicword('activity')}}</dd>
                <dd v-if="!istutor">{{$common.dicword(navsub==0?'stat':'submittime')}}</dd>
            </dl>
            <div class="listinfo">
                <dl class="avg" v-for="item in infolist" :key="item.id">
                    <dd v-if="istutor">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('learner',true)}}&nbsp;
                        </span>
                        {{item.username}}
                    </dd>
                    <dd v-else-if="isct&&!isviewstu">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('learner',true)}}&nbsp;
                        </span><ffmember :username="item.username" :stuid="item.mid"></ffmember>
                    </dd>
                    <dd v-if="isct&&!isviewstu&&1>2">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('infoclass',true)}}&nbsp;
                        </span>
                        <ffoverdot :title="item.grouptitle" :title_en="item.grouptitle_en"></ffoverdot>
                    </dd>
                    <dd v-if="isteaview">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('course',true)}}&nbsp;
                        </span><router-link :to="item.x_root+item.courseid" class="overparent"><ffoverdot :title="item.coursetitle" :title_en="item.coursetitle_en" :needtitle="false"></ffoverdot></router-link>
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('topic',true)}}&nbsp;
                        </span><router-link class="overparent" :to="item.x_root+item.courseid+'/'+item.topicid" :title="$common.langinfo(item.topictitle,item.topictitle_en)"><ffoverdot :title="item.topictitle" :title_en="item.topictitle_en" :needtitle="false"></ffoverdot></router-link>
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('lesson',true)}}&nbsp;
                        </span><router-link class="overparent" :to="item.x_root+item.courseid+'/'+item.lessonid" :title="$common.langinfo(item.lessontitle,item.lessontitle_en)"><ffoverdot :title="item.lessontitle" :title_en="item.lessontitle_en" :needtitle="false"></ffoverdot></router-link>
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('activity',true)}}&nbsp;
                        </span><a href="#" @click="showlearninfo(item.x_infoid)" :title="$common.langinfo(item.title,item.title_en)"><ffoverdot :title="item.title" :title_en="item.title_en" :needtitle="false"></ffoverdot></a>
                    </dd>
                    <dd v-if="!istutor">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword((navsub==0&&isstu)||isviewstu?'stat':'submittime',true)}}&nbsp;
                        </span>
                        {{(navsub==0&&isstu)||isviewstu?$common.langinfo(item.x_statitem.title,item.x_statitem.title_en):item.x_datesubmit}}
                    </dd>
                </dl>
            </div>

            <div class="ffpage" v-if="istea">
                <el-pagination :small="issmall" v-if="res.recordcount>res.ps" :background="true" :current-page.sync="res.cpage" :page-size="res.ps" layout=" prev, pager, next" :total="res.recordcount" @current-change="getdata">
                </el-pagination>
            </div>
        </div>


        <div class="memnorecord" v-else>{{$common.dicword('norecord')}}</div>
        <el-dialog v-if="isshowinfo" :visible.sync="isshowinfo" top="0px" class="mydialog2 modulewrap" append-to-body :show-close="!isreview" :close-on-click-modal="!isreview" :close-on-press-escape="!isreview">
            <div class="mydialogwrap">
                <Ccourseinfo :id="c_infocur.x_wid" :courseinfo="infocur" @ffsubmit="submitinfo" :islearning="c_options.schstat==1 && isstu" :isreview="isreview"></Ccourseinfo>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { mixinsubpage } from "@/mixin/mixin";
    export default {
        name: 'Cactivity',
        mixins: [mixinsubpage],
        components: {
            Ccourseinfo: () => import('@/components/Ccourseinfo')
        },
        data() {
            return {
                postact: 'tc_mem_work',
                infostat: [],
                isshowinfo: false,
                infocur: {},

                wid: 0//已阅未批的作业id
            };
        },
        computed: {
            c_infocur: function () {
                let _infocur = this.$common.basic.fffind(this.infolist, 'x_infoid', this.infocur.id);
                if (!this.$common.basic.isobjexist(_infocur)) {
                    _infocur = { 'x_wid': this.wid, 'stat': 3 };//已阅未批作业
                }
                return _infocur;
            },
            isreview: function () {
                return this.istutor && !this.c_options.isdone;
            }
        },
        methods: {
            getdata: function () {

                if (this.postjson.postdata.data.realid > 0) {
                    this.$common.post(this.postjson, res => {

                        let _infolist = [];
                        if (this.isteaview) {
                            this.$common.each(res.infodata, item2 => {

                                item2.title = item2.infotitle;
                                item2.title_en = '';
                                item2.coursetitle = '';
                                item2.coursetitle_en = '';
                                item2.topictitle = '';
                                item2.topictitle_en = '';
                                item2.lessontitle = '';
                                item2.lessontitle_en = '';


                                item2.grouptitle = '';
                                item2.grouptitle_en = '';
                                let cgroup = this.$common.basic.fffind(this.grouplist, 'id', item2.groupid);
                                if (this.$common.basic.isobjexist(cgroup)) {
                                    item2.grouptitle = cgroup.title;
                                    item2.grouptitle_en = cgroup.title_en;
                                }

                                let ccourse = this.$common.basic.fffind(res.infodatacourse, 'id', item2.courseid);
                                if (this.$common.basic.isobjexist(ccourse)) {
                                    item2.coursetitle = ccourse.title;
                                    item2.coursetitle_en = ccourse.title_en;
                                    item2.x_root = this.$common.tranlearnfolder(ccourse.typekv);
                                }

                                let ctopic = this.$common.basic.fffind(res.infodatatopic, 'id', item2.topicid);
                                if (this.$common.basic.isobjexist(ctopic)) {
                                    item2.topictitle = ctopic.title;
                                    item2.topictitle_en = ctopic.title_en;
                                }

                                let clesson = this.$common.basic.fffind(res.infodatalesson, 'id', item2.lessonid);
                                if (this.$common.basic.isobjexist(clesson)) {
                                    item2.lessontitle = clesson.title;
                                    item2.lessontitle_en = clesson.title_en;
                                }
                                item2.x_datesubmit = this.$common.basic.dateformat(item2.datesubmit);

                                item2.x_statitem = {};
                                let statitem = this.$common.basic.fffind(res.infodatastat, 'kv', item2.stat);
                                if (this.$common.basic.isobjexist(statitem)) {
                                    item2.x_statitem = statitem;
                                }


                                item2.x_wid = item2.id;
                                item2.x_infoid = item2.writingid;

                                _infolist.push(item2);

                            });
                            if (this.isreview) {
                                if (this.$common.basic.isobjexist(res.infodataread)) {
                                    this.showlearninfo(res.infodataread.writingid, res.infodataread.id);
                                }
                            }
                        }
                        else {
                            this.$common.each(res.infodatatopic, item => {
                                this.$common.each(res.infodata, item2 => {
                                    if (item2.pid == item.id) {
                                        item2.topictitle = item.title;
                                        item2.topictitle_en = item.title_en;
                                        item2.courseid = item.pid;
                                        item2.lessontitle = '';
                                        item2.lessontitle_en = '';
                                        item2.topicid = item.id;
                                        item2.lessonid = 0;
                                        item2.x_stat = 1;
                                        item2.x_wid = 0;
                                        item2.x_infoid = item2.id;


                                        item2.x_datesubmit = "-/-";
                                        let obj = this.$common.basic.fffind(res.infodatamine, 'writingid', item2.id);

                                        if (this.$common.basic.isobjexist(obj)) {
                                            item2.x_stat = obj.stat;
                                            item2.x_wid = obj.id;
                                            item2.x_datesubmit = this.$common.basic.dateformat(obj.datesubmit);
                                        }

                                        item2.x_statitem = {};
                                        let statitem = this.$common.basic.fffind(res.infodatastat, 'kv', item2.x_stat);
                                        if (this.$common.basic.isobjexist(statitem)) {
                                            item2.x_statitem = statitem;
                                        }

                                        _infolist.push(item2);

                                    }

                                });
                                this.$common.each(res.infodatalesson, item3 => {
                                    if (item3.pid == item.id) {
                                        this.$common.each(res.infodata2, item2 => {
                                            if (item2.pid == item3.id) {
                                                item2.topictitle = item.title;
                                                item2.topictitle_en = item.title_en;
                                                item2.courseid = item.pid;
                                                item2.lessontitle = item3.title;
                                                item2.lessontitle_en = item3.title_en;
                                                item2.topicid = item.id;
                                                item2.lessonid = item3.id;
                                                item2.x_stat = 1;
                                                item2.x_wid = 0;
                                                item2.x_infoid = item2.id;

                                                item2.x_datesubmit = "-/-";
                                                let obj = this.$common.basic.fffind(res.infodatamine, 'writingid', item2.id);
                                                if (this.$common.basic.isobjexist(obj)) {
                                                    item2.x_stat = obj.stat;
                                                    item2.x_wid = obj.id;
                                                    item2.x_datesubmit = this.$common.basic.dateformat(obj.datesubmit);
                                                }


                                                item2.x_statitem = {};
                                                let statitem = this.$common.basic.fffind(res.infodatastat, 'kv', item2.x_stat);
                                                if (this.$common.basic.isobjexist(statitem)) {
                                                    item2.x_statitem = statitem;
                                                }

                                                _infolist.push(item2);
                                            }

                                        });
                                    }


                                });
                            });
                        }

                        this.infolist = _infolist;
                        this.res = res;
                        this.infostat = res.infodatastat;
                    });
                }
                this.isload = true;
            },

            showlearninfo: function (v, wid = 0) {
                let jsondata = { 'postdata': { 'act': 'tc_learn_detail', 'id': v }, 'msg': '' };
                this.$common.post(jsondata, res => {
                    this.infocur = res.infodatadetail;
                    this.wid = wid;
                    this.isshowinfo = true;
                });
            },
            submitinfo: function (v) {
                this.c_infocur.x_stat = v;
                let statitem = this.$common.basic.fffind(this.infostat, 'kv', this.c_infocur.x_stat);
                if (this.$common.basic.isobjexist(statitem)) {
                    this.c_infocur.x_statitem = statitem;
                }
                this.isshowinfo = false;
            }
        }
    }
</script>
